<template>
    <v-flex>
        <h1 class="display-2">Configuraciones generales</h1>
        <br>
        <v-card>
            <v-card-text>
                <v-switch :label="valores.notifica.desc" v-model="valores.notifica.valor" @change="guardar('notifica')"></v-switch>
                <v-switch :label="valores.opSel.desc" v-model="valores.opSel.valor" @change="guardar('opSel')"></v-switch>
                <v-select
                        :items="estados"
                        :label="valores.estadoObs.desc"
                        v-model="valores.estadoObs.valor"
                        @change="guardar('estadoObs')"
                        item-text="desig"
                        item-value="id"
                        multiple
                        chips
                ></v-select>
                <v-text-field :label="valores.precioPorc.desc" v-model="valores.precioPorc.valor" @change="guardar('precioPorc')"></v-text-field>
                <v-btn color="blue" dark @click.native="test()">TEST AFIP-- NO USAR</v-btn>
                <v-btn color="blue" dark @click.native="testDifStock()">TEST DIF STOCK</v-btn>
            </v-card-text>
        </v-card>
    </v-flex>
</template>

<script>
    import {mapActions} from 'vuex';
    import mixinConfig from '../../mixins/config';
    import mixinPresup from '../../mixins/presupuesto';

    export default {
        name: "general",
        mixins: [mixinConfig, mixinPresup],
        data() {
            return {
                valores: {
                    opSel: {valor: '', id: '', desc: ''},
                    estadoObs: {valor: [], id: '', desc: ''},
                    precioPorc: {valor: [], id: '', desc: ''},
                    notifica: {valor: [], id: '', desc: ''},
                },
                estados: [],
                porcentajes:[],
                porcentajesSearch:''
            }
        },
        mounted() {
            this.estadosListado(r => {
                this.estados = r;
            }, err => {
                console.log(err)
            });
            this.configListado(r => {
                r.forEach(fld => {
                    this.valores[fld.nom] = {valor: fld.valor, id: fld.id, desc: fld.desc}
                });
            }, err => {
                console.log(err)
            })
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            guardar(item) {
                this.configSet({
                    valor: this.valores[item].valor,
                    id: this.valores[item].id
                }, r => {
                    this.msjShow(r);
                }, err => {
                    console.log(err)
                })
            },
            test() {
                this.$http.post('test/afip', this.d)
                    .then(r => {
                        alert(r.data)
                    })
                    .catch(err => {
                        alert(err)
                    })
            },
            testDifStock() {
                this.$http.post('stock/saldo/diferencia')
                    .then(r => {
                        console.log(r.data)
                    })
                    .catch(err => {
                        alert(err)
                    })
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/config/general.vue